import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.CHECK_TUTORIAL](state, tutorial) {
    Vue.set(state.checkedTutorials, tutorial, true);
  },

  [types.SET_CHECKED_TUTORIALS](state, checkedTutorials) {
    Vue.set(state, 'checkedTutorials', checkedTutorials);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/tutorials/store/mutations.js